module.exports = __webpack_public_path__ + "img/sv66.95b22fc4.svg";